// Tiempo de respuesta ofrecido al cliente (ver StoreGarantiaRequest: response_days solo
// acepta 15, 30 o 60).
export const GARANTIA_RESPONSE_DAYS_OPTIONS = [15, 30, 60];
